import { render, staticRenderFns } from "./SectionMain.vue?vue&type=template&id=15de995e&scoped=true&"
import script from "./SectionMain.vue?vue&type=script&lang=js&"
export * from "./SectionMain.vue?vue&type=script&lang=js&"
import style0 from "./SectionMain.vue?vue&type=style&index=0&id=15de995e&lang=scss&scoped=true&"
import style1 from "./SectionMain.vue?vue&type=style&index=1&id=15de995e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15de995e",
  null
  
)

export default component.exports